import React, { Component } from "react";
import { Document, Page, pdfjs } from "react-pdf";

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

class PdfLightbox extends Component {
  state = {
    numPages: null,
    pageNumber: 1,
    showLightbox: false,
  };

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };

  openLightbox = () => {
    this.setState({ showLightbox: true });
  };

  closeLightbox = () => {
    this.setState({ showLightbox: false });
  };

  render() {
    const { showLightbox, pageNumber, numPages } = this.state;
    const { file } = this.props;

    return (
      <div>
          <div style={styles.previewHeader}>
            <span>Zusätzliche Informationen: </span>
            <button onClick={this.openLightbox} style={styles.openButton}>
              <i className="fa fa-eye"/>
            </button>
          </div>
        {showLightbox && (
          <div style={styles.overlay}>
            <div style={styles.lightbox}>
              <button onClick={this.closeLightbox} style={styles.closeButton}>
                ×
              </button>

              <div style={styles.pdfWrapper}>
                {pageNumber > 1 && (
                  <button
                    onClick={() => this.setState({ pageNumber: pageNumber - 1 })}
                    style={{ ...styles.leftButton, left: 10 }}
                  >
                    ‹
                  </button>
                )}

                <div style={styles.pdfContainer}>
                  <Document file={file} onLoadSuccess={this.onDocumentLoadSuccess}>
                    <Page pageNumber={pageNumber} width={600} />
                  </Document>
                  <div style={styles.pageIndicator}>
                    Page {pageNumber} of {numPages}
                  </div>
                </div>

                {pageNumber < numPages && (
                  <button
                    onClick={() => this.setState({ pageNumber: pageNumber + 1 })}
                    style={{ ...styles.rightButton, right: 10 }}
                  >
                    ›
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const styles = {
  openButton: {
    background: "transparent",
    border: "none",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  lightbox: {
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    maxWidth: "90%",
    maxHeight: "90%",
    overflowY: "auto",
    position: "relative",
  },
  closeButton: {
    position: "fixed",
    top: 10,
    right: 15,
    fontSize: "24px",
    background: "rgba(0, 0, 0, 0.5)",
    border: "none",
    borderRadius: "50%",
    color: "#fff",
    width: "50px",
    height: "50px",
    cursor: "pointer",
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  pdfWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  leftButton: {
    position: "fixed",
    top: "50%",
    background: "rgba(0, 0, 0, 0.5)",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    padding: 0,
    fontSize: "24px",
    width: "50px",
    height: "50px",
    cursor: "pointer",
    zIndex: 5,
    transition: "background 0.3s",
    boxShadow: "0px 4px 6px rgba(0,0,0,0.3)",
  },
  rightButton: {
    position: "fixed",
    top: "50%",
    background: "rgba(0, 0, 0, 0.5)",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    padding: 0,
    width: "50px",
    height: "50px",
    fontSize: "24px",
    cursor: "pointer",
    zIndex: 5,
    transition: "background 0.3s",
    boxShadow: "0px 4px 6px rgba(0,0,0,0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },  
  pdfContainer: {
    textAlign: "center",
  },
  pageIndicator: {
    marginTop: "10px",
    fontSize: "16px",
  },
};

export default PdfLightbox;
